import React,{useEffect, useRef, useLayoutEffect} from 'react'
import ApexCharts from 'apexcharts'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faMagnifyingGlass, 
    faAngleDown,
    faFileExport 
} from '@fortawesome/free-solid-svg-icons';
import { useParams } from "react-router-dom";

import { PageTitle } from "../../../../../_template/layout/core/PageData";

const MissedChat = () => {
    const { company } = useParams();
    const loginUserType = localStorage.getItem('type');
    const api_base_url = process.env.REACT_APP_API_URL;

    const missedChatTitle = [
        {
            title: 'Agents',
            path: loginUserType === 'SA' ? `${company}/agents/` : '/agents',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
        {
            title: 'Report',
            path: loginUserType === 'SA' ? `${company}/report/missed-chat` : '/report/missed-chat',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
    ];

    const chartRef = useRef(null);

    useEffect(() => {
        setTimeout(() => {
            const chart = refreshChart();
                if (chart) {
                    chart.updateOptions({
                        chart: { height: 150 },
                    });
                }
            return () => {
                if (chart) {
                    chart.destroy();
                }
            };
        }, 200);
    }, [chartRef]);

    const refreshChart = () => {
        if (!chartRef.current) {
          return
        }
        const height = parseInt(150);
        const chart = new ApexCharts(chartRef.current, getChartOptions(height))
        if (chart) {
          chart.render()
        }
        return chart
    }


    return (
        <>
            <PageTitle breadcrumbs={missedChatTitle}>Missed Chat</PageTitle>
            <div className='row'>
                <div className="col-xl-3">
                    <a className="card bg-primary hoverable card-xl-stretch mb-xl-8 h-md-90">
                        <div className="card-body">
                            <span className="svg-icon svg-icon-white svg-icon-3x ms-n1">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mh-50px"><rect x="8" y="9" width="3" height="10" rx="1.5" fill="currentColor"></rect><rect opacity="0.5" x="13" y="5" width="3" height="14" rx="1.5" fill="currentColor"></rect><rect x="18" y="11" width="3" height="8" rx="1.5" fill="currentColor"></rect><rect x="3" y="13" width="3" height="6" rx="1.5" fill="currentColor"></rect></svg>
                            </span>
                            <div className="text-white fw-bold fs-3 mb-2 mt-5">
                                15
                            </div>
                            <div className="fw-semibold fs-5 text-white">
                                Missed User
                            </div>
                        </div>
                    </a>
                </div>
                <div className="col-xl-3">
                    <a className="card bg-primary hoverable card-xl-stretch mb-xl-8 h-md-90">
                        <div className="card-body">
                            <span className="svg-icon svg-icon-white svg-icon-3x ms-n1">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mh-50px"><rect x="8" y="9" width="3" height="10" rx="1.5" fill="currentColor"></rect><rect opacity="0.5" x="13" y="5" width="3" height="14" rx="1.5" fill="currentColor"></rect><rect x="18" y="11" width="3" height="8" rx="1.5" fill="currentColor"></rect><rect x="3" y="13" width="3" height="6" rx="1.5" fill="currentColor"></rect></svg>
                            </span>
                            <div className="text-white fw-bold fs-3 mb-2 mt-5">
                                03 hr 36 min
                            </div>
                            <div className="fw-semibold fs-5 text-white">
                                Missed Chat
                            </div>
                        </div>
                    </a>
                </div>
                <div className="col-xl-6">
                    <a className="card hoverable card-xl-stretch mb-xl-8 h-md-90 border">
                        <div className="card-body p-0">

                            <div ref={chartRef} id='kt_charts_widget_1_chart' style={{height: '150px'}} />

                            {/* <div className="fw-semibold fs-5 text-white">
                                Historical Data for Missed Chats Over the Last 7 Days
                            </div> */}
                        </div>
                    </a>
                </div>
            </div>
            <div className='row mb-5'>
                <div className='col-md-12'>
                    <div className='card border'>
                        <div className='card-body p-5'>
                            <div className='row'>
                                <div className='col-md-3'>
                                    <input type="text" className="form-control" placeholder="Select date"/>
                                </div>
                                <div className='col-md-3'>
                                    <input type="text" className="form-control" placeholder="Select date"/>
                                </div>
                                <div className='col-md-3'>
                                    <input type="text" className="form-control" placeholder="Select date"/>
                                </div>
                                <div className='col-md-3 text-end m-auto'>
                                    <button type="button" className="btn btn-dark btn-icon me-2 btn-sm">
                                        <FontAwesomeIcon icon={faAngleDown} />
                                    </button>
                                    <button type="button" className="btn btn-primary btn-icon btn-sm">
                                        <FontAwesomeIcon icon={faMagnifyingGlass} className=''/>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col-md-12'>
                    <div className='card card-flush border'>
                        <div className="card-header pe-5">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label fw-bold text-gray-800 fs-2">
                                    Report Chat
                                </span>
                                <span className="text-gray-400 mt-1 fw-semibold fs-6">
                                    Total 0 chat report are available
                                </span>
                            </h3>
                            <div className='card-toolbar'>
                                <button type="button" className="btn btn-dark btn-sm">
                                    <FontAwesomeIcon icon={faFileExport} /> CSV Export
                                </button>
                            </div>
                        </div>
                        <div className='card-body py-0'>
                            <div className="table-responsive">
                                <table className="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
                                    <thead>
                                        <tr className="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
                                            <th className="w-250px sorting">
                                                Session
                                            </th>
                                            <th className="w-250px sorting">
                                                Public IP
                                            </th>
                                            <th className="w-250px sorting">
                                                User Details
                                            </th>
                                            <th className="w-250px sorting">
                                                Product Enquiry
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-gray-600 fw-semibold set-system-user-list">
                                        <tr className="">
                                            <td>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="d-flex justify-content-start flex-column">
                                                            <a className="text-gray-600 fw-bold fs-6">
                                                                Date Time
                                                            </a>
                                                            <span className="text-gray-800 fw-semibold d-block fs-7">
                                                                27 Nov 2024 10:07
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mb-2">
                                                        <div className="d-flex justify-content-start flex-column">
                                                            <a className="text-gray-600 fw-bold fs-6">
                                                                Session Duration
                                                            </a>
                                                            <span className="text-gray-800 fw-semibold d-block fs-7">
                                                                5 min
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="row">
                                                    <div className="col-md-12 mb-2">
                                                        <div className="d-flex justify-content-start flex-column">
                                                            <span className="text-gray-600 fw-semibold d-block fs-7">
                                                                171.78.185.110
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <span className="badge badge-light-success">
                                                            Unique
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='row'>
                                                    <div className='col-md-12'>
                                                        <div className="d-flex flex-column">
                                                            <a className="text-gray-800  mb-1">
                                                                User One
                                                            </a>
                                                            <span>
                                                                <div className="badge badge-light-dark fw-bold">
                                                                    542148754
                                                                </div>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='row'>
                                                    <div className='col-md-12'>
                                                        <span className="me-2">
                                                            <div className="badge badge-light fw-bold mb-1">
                                                                Product 1
                                                            </div>
                                                        </span>
                                                        <span className="me-2">
                                                            <div className="badge badge-light fw-bold mb-1">
                                                                Product 2
                                                            </div>
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
        
    )
}

export {MissedChat}

function getChartOptions() {
    const labelColor = '#A1A5B7';
    const borderColor = '#eff2f5';
    const baseColor = '#009ef7';
    const secondaryColor = '#009ef7'
  
    return {
      series: [
        {
          name: 'Net Profit',
          data: [44, 55, 57, 56, 61, 58],
        },
        {
          name: 'Revenue',
          data: [76, 85, 101, 98, 87, 105],
        },
      ],
      chart: {
        fontFamily: 'inherit',
        type: 'bar',
        height: 350,
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '30%',
          borderRadius: 5,
        },
      },
      legend: {
        show: false,
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent'],
      },
      xaxis: {
        categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          style: {
            colors: labelColor,
            fontSize: '12px',
          },
        },
      },
      yaxis: {
        labels: {
          style: {
            colors: labelColor,
            fontSize: '12px',
          },
        },
      },
      fill: {
        opacity: 1,
      },
      states: {
        normal: {
          filter: {
            type: 'none',
            value: 0,
          },
        },
        hover: {
          filter: {
            type: 'none',
            value: 0,
          },
        },
        active: {
          allowMultipleDataPointsSelection: false,
          filter: {
            type: 'none',
            value: 0,
          },
        },
      },
      tooltip: {
        style: {
          fontSize: '12px',
        },
        y: {
          formatter: function (val) {
            return '$' + val + ' thousands'
          },
        },
      },
      colors: [baseColor, secondaryColor],
      grid: {
        borderColor: borderColor,
        strokeDashArray: 4,
        yaxis: {
          lines: {
            show: true,
          },
        },
      },
    }
}